.note {
  display: grid;
  gap: 4px;
  padding: 8px 10px;
  border: 1px dashed var(--line);
  border-radius: 6px;
  background: var(--panel);
}

.head {
  display: flex;
  align-items: center;
  gap: 6px;
  margin: 0;
  font-size: var(--t-dense);
  font-weight: 650;
  color: var(--ink);
}

.glyph {
  flex: none;
  color: var(--muted);
}

.list {
  display: grid;
  gap: 2px;
  margin: 0;
  padding: 0;
  list-style: none;
}

.list li {
  display: flex;
  flex-wrap: wrap;
  gap: 2px 12px;
  align-items: baseline;
  font-size: var(--t-dense);
}

.link {
  display: inline-flex;
  align-items: center;
  min-height: var(--target-min);
  color: var(--accent);
  font-weight: 650;
  text-decoration: none;
}

.link:hover {
  text-decoration: underline;
}

.meta {
  font-size: var(--t-min);
  color: var(--muted);
}

.honest {
  margin: 0;
  font-size: var(--t-min);
  color: var(--muted);
}
